var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSavedToDisco = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M8.015 18.57h2.948c3.109 0 5.708-1.93 5.708-6.057S14.1 6.43 10.99 6.43H8.015V8.81H4.317V3h6.807c5.413 0 9.38 3.51 9.38 9.513S16.51 22 11.096 22h-6.78v-5.809h3.698zm2.594-1.638L15.04 12.5l-4.432-4.432-.964.948 2.814 2.814H3.497v1.34h8.962l-2.814 2.814z"
})));
export default SvgSavedToDisco;